import React from 'react';
import './css/index.scss';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import TableCell from '../../../../components/TableCell';
import TableRow from '../../../../components/TableRow';

function OperationItem({
  item, widths, index,
}) {
  const navigate = useNavigate();

  const onOperationClick = () => {
    navigate(`/operations/single-view?id=${item._id}`);
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'pending':
        return 'Выполняется';
      case 'success':
        return 'Успешно';
      case 'error':
        return 'Ошибка';
      default:
        return status;
    }
  };

  const getTypeText = (type) => {
    switch (type) {
      case 'parsingEventsFromKontramarka':
        return 'Парсинг Kontramarka';
      case 'parsingEventsFromFienta':
        return 'Парсинг Fienta';
      case 'parsingEventsFromEventim':
        return 'Парсинг Eventim';
      case 'sendNewOrganizationsNotifications':
        return 'Отправка уведомлений о новых организациях';
      case 'sendNewEventsNotifications':
        return 'Отправка уведомлений о новых мероприятиях';
      case 'sendNewOnlineOrganizationsNotifications':
        return 'Отправка уведомлений о новых онлайн организациях';
      default:
        return type;
    }
  };

  return (
    <TableRow key={item._id} onClick={onOperationClick} style={{ cursor: 'pointer' }}>
      <TableCell width={widths[0]}>{getTypeText(item.type)}</TableCell>
      <TableCell width={widths[1]}>
        {item.createdAt ? moment(item.createdAt).format('DD/MM/YYYY HH:mm:ss') : '—'}
      </TableCell>
      <TableCell width={widths[2]}>
        {item.finish_time ? moment(item.finish_time).format('DD/MM/YYYY HH:mm:ss') : '—'}
      </TableCell>
      <TableCell width={widths[3]}>{getStatusText(item.status)}</TableCell>
      <TableCell width={widths[4]} />
    </TableRow>
  );
}

export default OperationItem;

